import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Comentario } from '@app/core/entities/comentario/comentario';
import { AnalisisFuncionalInterface } from '@app/core/interfaces/analisis-funcional-interface';
import { ComentarioInterface } from '@app/core/interfaces/comentario-interface';
import { IRequestPostConceptos } from '@app/core/interfaces/IConceptos';
import { RequestPostHitosFacturacionPropuesta } from '@app/core/interfaces/IHitosFacturacion';
import { IRequestPostMantenimiento } from '@app/core/interfaces/IMantenimientos';
import { ILineaInfraestructura, LineaInfraestructuraPropuesta, LineaInfraestructuraPropuestaFiltros, RequestPostLineaInfraestructuraPropuesta } from '@app/core/interfaces/linea-infraestructura';
import { IRespApi } from '@app/neo/neoShared/helpers/interfaces/IResp-api';
import { EstadosPropuesta, EstadosPropuestaNombre } from '@app/admin/pages/oportunidades/helpers/enums/estados-propuesta.enum';
import { EstimacionesDepartamento, EstimacionInterface, PropuestaEstado, PropuestaInterface, RequestPatchEstadoPropuesta, RequestPatchEstimacionActual, RequestPatchPropuesta, RequestPostAnalisisFuncional, RequestPostEnviarPropuestaPdf, RequestPostRequisitos, RequisitosInterface } from '@app/admin/pages/oportunidades/helpers/interfaces/propuesta-interface';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, forkJoin, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ProyectoItemsService } from '../proyectos/proyecto-items.service';
import { ProyectosService } from '../proyectos/proyectos.service';
import { TiposMetodoPagoService } from '../tipos/tiposMetodoPago/tipos-metodo-pago.service';
import { LOADER_TRANSPARENT } from '@app/neo/neoCore/interceptors/loaderInterceptor/loader.interceptor';

@Injectable({
  providedIn: 'root'
})
export class PropuestasService {
  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };

  public editando$ = new BehaviorSubject<boolean>(false);
  public editandoRequisitos$ = new BehaviorSubject<boolean>(false);
  public editandoHitos$ = new BehaviorSubject<boolean>(false);

  urlPropuestas = environment.api_base_url + '/propuestas';
  urlPropuestasEstados = environment.api_base_url + '/propuestaEstados';
  urlTextos               = environment.api_base_url + '/textos';
  urlFicheros             = environment.api_base_url + '/ficheros';
  nombreEntidad = 'propuesta';
  public error422Api$: Subject<RespApi> = new Subject<RespApi>();
  public propuesta$: BehaviorSubject<PropuestaInterface> = new BehaviorSubject<PropuestaInterface>(null);
  // Utilizado para actualizar componentes dependientes pero que no producen cambios en la entidad propuesta: ej: hitos y conceptos.
  public flagActualizarRelacion$: BehaviorSubject<Boolean> = new BehaviorSubject<Boolean>(false);
  public totalPropuestas$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  public estadosPropuestas: PropuestaEstado[];

  
  constructor(
    private http: HttpClient,
    private proyectoItemsServicio: ProyectoItemsService,
    private proyectosService: ProyectosService,
    private tiposMetodoPagoService: TiposMetodoPagoService,    
    private auxiliar: AuxiliarService,
    private datepipe: DatePipe
  ) { 
    this.cargarEstados();
  }

 
  cargarEstados() {
    this.getEstados().subscribe(data => this.estadosPropuestas = data);
  }
  get _EstadosPropuestas() {
    return EstadosPropuesta;
  }

  get _EstadosPropuestaNombre() {
    return EstadosPropuestaNombre;
  }

  set editando(flag: boolean) {
    this.editando$.next(flag);
  }

  set editandoRequisitos(flag: boolean) {
    this.editandoRequisitos$.next(flag);
  }

  set editandoHitos(flag: boolean) {
    this.editandoHitos$.next(flag);
  }

  get _EstimacionDefault() {
    return {
      'SW-ADR'        : {horasMin: 0, horasMax: 0},
      'SW-IOS'        : {horasMin: 0, horasMax: 0},
      'SW-BACK'       : {horasMin: 0, horasMax: 0},
      'SW-DIR'        : {horasMin: 0, horasMax: 0},
      'DIS'           : {horasMin: 0, horasMax: 0},
      'SW-MAQU'       : {horasMin: 0, horasMax: 0},
      'ADM'           : {horasMin: 0, horasMax: 0},
    }
  }

  // uso para mejora tiempo evitando el mapeo en casos innecesarios como en listado oportunidades
  set flagActualizarRelacion( flag: boolean ) {
    this.flagActualizarRelacion$.next(true);
  }

  set propuesta(propuesta: PropuestaInterface) {
    console.log('DEBUG-DETAIL Estableciendo propuesta ', propuesta);
    this.propuesta$.next(propuesta);
    // if ( propuesta ) {
    //   this.entidadesRelacionadas( propuesta ).subscribe( response => {
    //     console.log('DEBUG-DETAIL Estableciendo propuesta entidadesRelacionadas ', response);
    //     let tipoMetodoPago         = response[0];
    //     let proyectoItem           = response[1];
    //     let proyectoTipo           = response[2];
    //     let analisisFuncional      = response[3];
    //     let estimacion             = response[4];
    //     let requisitos = response[5];
    //     let tieneRequisitos        = this.comprobarTieneRequisitos( requisitos );
    //     let tieneAnalisisFuncional = this.comprobarTieneAnalisiFuncional( analisisFuncional );
    //     let tieneEstimacion        = this.comprobarTieneEstimacion( estimacion )
    //     // let lineasInfraestructura= response[5];
    //     let fechaFormatt = new Date(propuesta?.fecha);
    //     let propuestaMapeada = { ...propuesta, tipoMetodoPago, proyectoItem, proyectoTipo, analisisFuncional, estimacion, requisitos, tieneAnalisisFuncional, tieneEstimacion, tieneRequisitos, fechaFormatt};
    //     this.propuesta$.next(propuestaMapeada);
    //   },
    //     (error) => console.log('ERROR entidades relacionadas propuestas', error))
    // }
  }

  vaciarPropuesta() {
    this.propuesta$.next(null);
  }

  setPropuesta(propuesta: PropuestaInterface,  mapeada: boolean = false) {
    if ( propuesta ) {
      if ( mapeada ) {
        console.log('DEBUG-DETAIL setOportunidad setPropuesta', propuesta);
        this.propuesta = propuesta;
      } else {
        this.propuesta$.next(propuesta);
      }
    }
  }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<object[]> {
    if (paginatorType === TipoPaginadorEnum.offline) {
      return this.http.get(`${this.urlPropuestas}?${ this.auxiliar.extraerFiltros(filtros) }`, {})
      .pipe(
        tap( (data: RespApi )=> {
          this.totalPropuestas$.next( data.total );
        }),
        map((data: RespApi) => this.mapearPropuestas(data['data']) ));
    } else {
      return this.http.get(`${this.urlPropuestas}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, {}).pipe(
        tap( (data: RespApi )=> {this.totalPropuestas$.next( data.total );}),
        map((data: RespApi) => this.mapearPropuestas(data['data']) ));
      }
  }

  mapearPropuestas( propuestas: PropuestaInterface[] ) {
    if (propuestas.length) {
      propuestas.forEach((element, index )=> {
        propuestas[index].propuestaEstadoActual.esFinal = this.auxiliar.getBoolean(element?.propuestaEstadoActual.esFinal );
        propuestas[index].fecha = new Date( element.fecha);
      });
    }
    return propuestas;
  }

  get(id): Observable<PropuestaInterface>{
    return this.http.get(`${this.urlPropuestas}/${id}`).pipe(
      map((data: RespApi) => 
      {
        data['data'].puedoEditarTipoAndNombreProyecto = this.auxiliar.getBoolean(data['data'].puedoEditarTipoAndNombreProyecto);
        return data['data'];
      })
    );
  }
  
  mapearPropuesta( propuesta: PropuestaInterface ) {
    if (propuesta) {
      propuesta.fechaFormatt = new Date( propuesta.fecha);   
    }
    return propuesta;
  }
  
  
  update(id: string, request: RequestPatchPropuesta) {
    console.log('Update propuesta ', id, request);
    return this.http.patch( `${this.urlPropuestas}/${id}`, request ).pipe(
      tap((data: RespApi) => console.log('Respuesta ', data)),
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPatchPropuesta');
      })
    );
  }

  entidadesRelacionadas(propuesta: PropuestaInterface) {
    console.log('DEBUG-DETAIL Estableciendo propuesta entidadesRelacionadas() ');
    const responseTipoMetodoPago = this.tiposMetodoPagoService.get(propuesta?.idTipoMetodoPago);
    const responseProyectoTipo            = this.proyectosService.getProyectoTipo(propuesta?.idProyectoTipo);
    const responseProyectoItem = this.proyectoItemsServicio.get(propuesta?.idProyectoItem);
    const responseAnalisisFuncional       = this.getAnalisisFuncional(propuesta?.id);
    const responseEstimacion              = this.getEstimacionActual( propuesta?.id );
    // const responseLineasInfraestructura   = this.getLineasInfraestructura(propuesta?.id);
    const responseRequisitos              = this.getRequisitos( propuesta?.id )
    return forkJoin([
      responseTipoMetodoPago,
      responseProyectoItem,
      responseProyectoTipo,
      responseAnalisisFuncional,
      responseEstimacion,
      // responseLineasInfraestructura,
      responseRequisitos
    ]).pipe(
      catchError(error => of(error))
    );;
  }

  _entidadesRelacionadas(propuesta: PropuestaInterface) {
    let peticion = {
      proyectoItem: this.proyectoItemsServicio.get(propuesta?.idProyectoItem).pipe(
        catchError(err => of(null))
      ),
      analisisFuncional: this.getAnalisisFuncional(propuesta?.id).pipe(
        catchError(err => of(null))
      ),
      estimacion: this.getEstimacionActual(propuesta?.id).pipe(
        catchError(err => of(null))
      ),
      requisitos: this.getRequisitos(propuesta?.id).pipe(
        catchError(err => of(null))
      ),
      // lineasInfraestructura: this.getLineasInfraestructura(proyectoItem?.id).pipe(
      //   catchError(err => of(null))
      // ),
      // conceptos: this.getConceptos( proyectoItem?.id ).pipe(
      //   catchError(err => of(null))
      // ),
    };
    return forkJoin(peticion);
  }



  getEstados(): Observable<PropuestaEstado[]>  {
    return this.http.get(`${this.urlPropuestasEstados}`).pipe(
      map((data: RespApi) => data['data'])
    );
  }

  updateEstado(id: string, request: RequestPatchEstadoPropuesta) {
    if (!request['motivo']) {
      request['motivo'] = '';
    }
    return this.http.post( `${this.urlPropuestas}/${id}/establecerEstado`, request ).pipe(
      map((data: PropuestaInterface[]) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPatchEstadoPropuesta');
      })
    );
  }

  getPropuestaPdf(id: string): Observable<string> {
    return this.http.get(`${this.urlPropuestas}/${id}/propuestaPdf`, { ...this.contextLoaderTransparent }).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {  
        return this.handleError( err,  'RequestReactivarPropuesta');
      })
    );
  }

  sendPropuestaPdf(id: string, request: RequestPostEnviarPropuestaPdf) {
    return this.http.post(`${this.urlPropuestas}/${id}/enviarPdf`, request, { ...this.contextLoaderTransparent }).pipe(
      map((data) => !data['error']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPostEnviarPropuestaPdf');
      })
    );
  }

  reactivarPropuesta(id) {
    return this.http.post( `${this.urlPropuestas}/${id}/reactivar`, {} ).pipe(
      map((data: PropuestaInterface[]) => data['data']),
      catchError( (err: RespApi) => {  
        return this.handleError( err,  'RequestReactivarPropuesta');
      })
    );
  }


  /****************************/
  /* ANALISIS FUNCIONAL       */
  /*****************************/
  getAnalisisFuncional(id: string): Observable<AnalisisFuncionalInterface> {
    return this.http.get( `${this.urlPropuestas}/${id}/analisisFuncional`).pipe(
      map((data: RespApi) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'getAnalisisFuncional');
      })
    );
  }  

  setAnalisisFuncional(id: string, request: RequestPostAnalisisFuncional) {
    return this.http.post( `${this.urlPropuestas}/${id}/analisisFuncional`, request ).pipe(
      map((data) => !data['error']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPostAnalisisFuncional');
      })
    );
  }

  tieneAnalisisFuncional(id: string):Observable<any> {
    return this.getAnalisisFuncional( id ).pipe(
      map( af => this.comprobarTieneAnalisiFuncional(af) )
    )
  }

  comprobarTieneAnalisiFuncional(af: AnalisisFuncionalInterface): boolean {
    return af?.queHaremosDescripcionGeneral?.contenido !== '';
    // return af?.queHaremosDescripcionGeneral.contenido !== '' && af?.queHaremosDescripcionTecnica.contenido !== '' && af?.queNecesitamos.contenido !== ''
  }

  /****************************/
  /* ESTIMACION                */
  /*****************************/
  getEstimacionActual(id: string): Observable<EstimacionInterface> {
    return this.http.get( `${this.urlPropuestas}/${id}/estimacionActual`).pipe(
      map((data: RespApi) => data['data']),
      map((data: EstimacionInterface) => 
      {
        let estimacion = data;
        estimacion.activa = this.auxiliar.getBoolean(data?.activa );
        return data;
      })
    );
  }

  setEstimacionActual(id: string, request: RequestPatchEstimacionActual) {
    return this.http.patch( `${this.urlPropuestas}/${id}/estimacionActual`, request ).pipe(
      map((data) => !data['error']),
      catchError( (err: RespApi) => {     
        return this.handleError( err );
      })
    );
  }

  getEstimacionActualDepartamento(id: string):  Observable<{[key: string]: EstimacionesDepartamento}> {
    return this.getEstimacionActual( id ).pipe(
      map(data => data['estimacionesDepartamento'])
    );
  }

  tieneEstimacion(id: string):Observable<any> {
    return this.getEstimacionActual( id ).pipe(
      map( estimacion => this.comprobarTieneEstimacion(estimacion) )
    )
  }

  comprobarTieneEstimacion(estimacion: EstimacionInterface): boolean {
    return Number(estimacion?.tiempoTotalMinimo) >0;
  }
  /****************************/
  /* FICHEROS                */
  /*****************************/
  getFicheros(id: string) {
    console.log('[Ficheros llamada]');
    return this.http.get(`${this.urlPropuestas}/${id}/ficheros?clave=fichero`).pipe(
      map((data: RespApi) => data['data'] ));
  }

  subirFicheros(idEntidad: string, request: any) {
    console.log('Subir ficheros ', idEntidad);
    return this.http.post<IRespApi>(`${this.urlPropuestas}/${idEntidad}/ficheros`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPost' + this.nombreEntidad + 'Fichero');
      })
    );
  }
  editarFichero(idFichero: string, request: any) {
    return this.http.patch<IRespApi>(`${this.urlFicheros}/${idFichero}/ficheros`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestEditar' + this.nombreEntidad + 'Fichero');
      })
    );
  }

  eliminarFichero(id: string, idFichero?: string) {

    if (id) {
      let peticion = `${this.urlPropuestas}/${id}/ficheros`;
      if (idFichero) {
        peticion = `${peticion}/${idFichero}`;
      }
      return this.http.delete(peticion).pipe(
        map((data: IRespApi) => data),
        catchError( (err: RespApi) => {       
          return this.handleError(err, 'IRequestDelete' + this.nombreEntidad + 'Fichero');
        })
      );
    } else {
      return throwError(new Error('Error intentando eliminar fichero sin especificar id'));
    }
  }



  postFile(fileToUpload: File[], idObjeto: string): Observable<any> {
    const formData: FormData = new FormData();
    if(fileToUpload?.length){
      for(let i=0 ; i < fileToUpload.length ; i++)
      formData.append('fichero[]', fileToUpload[i],fileToUpload[i].name);
    }
    return this.http.post(`${this.urlPropuestas}/${idObjeto}/ficheros`, formData).pipe(
      map( (data:RespApi) => data),
      catchError( (err: RespApi) => {     
        return this.handleError( err, 'RequestSubidaFicheros' );
      })
    );     
  }

 


  /*********************/
  /* REQUISITOS       */
  /*********************/
  getRequisitos(id: string) {
    return this.http.get( `${this.urlPropuestas}/${id}/requisitos`).pipe(
      map((data: RespApi) => data['data'] ));
  }


  updateRequisitos(request: RequestPostRequisitos, idObjeto: string): Observable<any> {
    return this.http.post(`${this.urlPropuestas}/${idObjeto}/requisitos`, request).pipe(
      map( (data:RespApi) => data),
      catchError( (err: RespApi) => {     
        return this.handleError( err );
      })
    );     
  }

   // Funcion que reusa endpoint
   tieneRequisitos(id: string):Observable<any> {
    return this.getRequisitos( id ).pipe(
      map( data => (data.contenido !== '') )
    )
  }

  comprobarTieneRequisitos(req: RequisitosInterface): boolean {
    console.log('DEBUG-DETAIL ', req);
    return (req && req?.contenido && req.contenido !== '');
  }


  /*********************/
  /* COMENTARIOS       */
  /*********************/
  getComentarios(propuesta): Observable<Comentario[]> {
    let filtros = { orden: 'id', tipoOrden: 'asc' };
    return this.http.get(`${this.urlPropuestas}/${propuesta.id}/comentarios?${this.auxiliar.extraerFiltros(filtros)}`).pipe(
      map((data: RespApi) => this.mapearComentario(data.data, propuesta.id))
    );
 
  }

  mapearComentario(comentarios: Comentario[], idObjeto: string): Comentario[] {
    comentarios.map(object => Object.assign(object, {
      idObjeto,
    }));
    return comentarios;
  }

  createComentario(comentario: ComentarioInterface): Observable<any> {
    if( comentario ) {
      const objComentario = Object.assign({texto: comentario.contenido});
      return this.http.post(`${this.urlPropuestas}/${comentario.idObjeto}/comentarios`, objComentario).pipe(
        map( (data:RespApi) => data),
        catchError( (err: RespApi) => {       
          return this.handleError( err );
        })
      );     
    } else {
      return throwError(new Error('Error'));
    }
    
  }

  updateComentario(comentario: ComentarioInterface): Observable<any> {
    const objComentario = Object.assign({texto: comentario.contenido});
    return this.http.patch( `${this.urlTextos}/${comentario.id}`, objComentario ).pipe(
      map((data: ComentarioInterface[]) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError(err);
      })
    );
  }

  deleteComentario(comentario: ComentarioInterface): Observable<any> {
    if (comentario) {
      return this.http.delete(`${this.urlTextos}/${comentario.id}`).pipe(
        map((data: ComentarioInterface[]) => data['data']),
        catchError( (err: RespApi) => {       
          return this.handleError(err);
        })
      );
    } else {
      return throwError(new Error('Error'));
    }
  }


  
  /********************************/
  /* MANTENIMIENTOS       */
  /********************************/

  createMantenimientoPropuesta(id: string, request: IRequestPostMantenimiento) {
    return this.http.post( `${this.urlPropuestas}/${id}/mantenimiento`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'IRequestPostMantenimiento');
      })
    );
  }


  /********************************/
  /* LINEAS INFRAESTRUCTURA       */
  /********************************/
  // get all secuendario, devolvemos el total
  getLineasInfraestructura(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: LineaInfraestructuraPropuestaFiltros): Observable<any> {
    console.log('DEBUG-DETAIL Linea de infraestructura ', `${this.urlPropuestas}/${id}/lineaInfraestructuras?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`);
    return this.http.get(`${this.urlPropuestas}/${id}/lineaInfraestructuras?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`)
    .pipe(
      map((data: RespApi) => {
      return {lineas: this.mapearLineasInfraestructura(data.data), total: data.total} }
      ),
      catchError((err: RespApi) => {
        return this.handleError(err, 'getLineasInfraestructura');
      })
    ); 
  }
  
  private mapearLineasInfraestructura( lineas: LineaInfraestructuraPropuesta[] ) {
    if (lineas.length) {
      lineas.forEach((element, index )=> {
        lineas[index] = this.mapearLineaInfraestructuraPropuesta( element );
      });
    }
    return lineas;
  }

  private mapearLineaInfraestructuraPropuesta( linea: LineaInfraestructuraPropuesta ):LineaInfraestructuraPropuesta{
    linea.importe  = +linea.importe;
    linea.unidades = +linea.unidades;
    return linea;
  }

  createLineaInfraestructuraPropuesta(id: string, request: RequestPostLineaInfraestructuraPropuesta) {
    return this.http.post( `${this.urlPropuestas}/${id}/lineaInfraestructuras`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPostLineaInfraestructuraPropuesta');
      })
    );
  }
  

  /********************************/
  /* CONCEPTOS       */
  /********************************/
  getConceptos(id): Observable<any> {
    return this.http.get(`${this.urlPropuestas}/${id}/conceptos`)
    .pipe(
      map((data: RespApi) => data['data']))
  }

  createConceptos(id: string, request: IRequestPostConceptos): Observable<any>{
    return this.http.post<RespApi>( `${this.urlPropuestas}/${id}/conceptos`, request ) .pipe(
      map( (resp: RespApi) => resp.data),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'IRequestPostConceptos');
      })
    );
  }

   /********************************/
  /* HITOS FACTURACION       */
  /********************************/
  getHitosFacturacion(id): Observable<any> {
    return this.http.get(`${this.urlPropuestas}/${id}/hitosFacturacion`)
    .pipe(
      map((data: RespApi) => data['data']))
  }

  createHitosFacturacion(id: string, request: RequestPostHitosFacturacionPropuesta): Observable<any>{
    request.hitosFacturacion.map(hito => {
      hito.idFacturacionConfiguracion = hito.idFactHitoConfiguracion
      if (hito.fecha) {
        hito.valor = this.datepipe.transform(hito.fecha, 'dd/MM/yyyy');
      }
      if (hito['numero']) {
        hito.valor = hito['numero'];
      }
    });
    console.log(request);
    return this.http.post<RespApi>( `${this.urlPropuestas}/${id}/hitosFacturacion`, request ) .pipe(
      map( (resp: RespApi) => resp.data),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPostHitosFacturacionPropuesta');
      })
    );
  }

  /************************************ 
   * Funciones apoyo                  *
  *************************************/
  obtenerEstadoPropuesta( idEstado: string) {
    return this.estadosPropuestas?.find( estado => estado.id === idEstado);
  }

  /********************************/
  /* MANEJADOR ERRORES            */
  /********************************/
  private handleError(err: RespApi, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    if (err == 'Unknown Error') {
      let mensaje = environment.errorServidorUnknown;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    // dialog específico
    console.log('propuesta service handleError', err);
    err.request = idRequest;
    if ( err.codigoError === 422) {
      this.error422Api$.next(err);
    } 

    // pantalla común
    let mensaje = err?.mensaje;
    if ( err.codigoError === 403) {
      mensaje = `${ err.mensaje }: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404  || err.codigoError === 422) {
      let avisos = '';
      if ( err.data ) {
        err.data.forEach(element => {
          if ( element.id === 999 ) {
            avisos = ' ' + element.mensaje + ' ';
          }
        });
      }
      mensaje = (avisos.length)  ? avisos : err?.mensaje;
    }

    if (err.codigoError === 500) {
      let avisos = '';
      if ( err.data ) {
        err.data.forEach(element => {
          if ( element.id === 999 ) {
            avisos = ' ' + element.mensaje + ' ';
          }
        });
      }
      mensaje = err?.mensaje +  avisos;
    }
    console.log(` Error Operacion ${err.data} ${mensaje} ${err}`);
    return throwError({'error' : true, 'data': err.data, mensaje, 'err': err });
  }

  
  
}
